/* src/app/modules/search/components/doc-view/components/toolbar/toolbar.component.scss */
.toolbar-container ::ng-deep .pi {
  font-size: 1rem !important;
}
.toolbar-container ::ng-deep .p-speeddial-button {
  width: 2rem !important;
  height: 2rem !important;
  color: var(--primary-700);
  background: var(--surface-a);
}
.toolbar-container ::ng-deep .p-speeddial-action {
  width: 2rem !important;
  height: 2rem !important;
  background: var(--surface-a);
  color: var(--primary-700);
  box-shadow:
    0px 3px 5px rgba(0, 0, 0, 0.02),
    0px 0px 2px rgba(0, 0, 0, 0.05),
    0px 1px 4px rgba(0, 0, 0, 0.08);
}
.button-container .material-symbols-outlined {
  color: var(--primary-700);
}
/*# sourceMappingURL=toolbar.component.css.map */
